import React from "react";

import { AppButton } from "components/form";

// AppSectionErrorBoundary that will catch any errors that occur in the section
// and display a friendly blurred background on the section indicating an error.

export class AppSectionErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <div
            className="app-section-error-boundary  "
            data-testid="app-section-error-boundary"
          >
            <div className="app-section-error-boundary__content ">
              <div className="app-section-error-boundary__background"></div>
              <div className="app-section-error-boundary__content__title">
                Oops!
              </div>

              <div className="app-section-error-boundary__content__message">
                Something went wrong. Please try again.
              </div>

              <div className="app-section-error-boundary__content__message">
                If the problem persists, please contact support.
              </div>

              <AppButton
                className="mt-3"
                onClick={() => window.location.reload()}
                dataTestId="refresh-button"
              >
                Refresh
              </AppButton>
            </div>
          </div>
        </div>
      );
    }

    return (this.props as { children: React.ReactNode }).children;
  }
}
